import { call, put, select, takeLatest } from "redux-saga/effects"

import flattenFilters from "../../utils/flattenFilters"
import { getCompanyRanking, loadCompanyRankings, loadSurveyCompanies } from "../services/rankings.service"
import * as Actions from "./rankings.actions"
import { getCompaniesRankingOffset } from "./rankings.selectors"

export function* loadSaga(action) {
  try {
    const res = yield call(loadCompanyRankings, action.payload)
    const companyRankings = res && res.data && res.data.allCompanyRanking
    if (companyRankings) {
      if (action.type === Actions.types.LOAD_COMPANY_RANKINGS) {
        yield put(Actions.loadCompanySuccess(companyRankings))
      }
      if (action.type === Actions.types.LOAD_MORE) {
        yield put(Actions.loadMoreSuccess(companyRankings))
      }
    } else {
      yield put(Actions.loadFail())
    }
  } catch (e) {
    yield put(Actions.loadFail())
  }
}

export function* getSurveyCompaniesSaga(action) {
  try {
    const res = yield call(loadSurveyCompanies, action.payload)
    if (res?.data?.getSurveyCompanies)
      yield put(Actions.getSurveyCompaniesSuccess(res.data.getSurveyCompanies))
  } catch {
    yield put(Actions.getSurveyCompaniesFail())
  }
}

export function* loadCompaniesSaga(action) {
  try {
    const filters = action?.payload
    const offset = yield select(getCompaniesRankingOffset) || 0

    const filtersValuesUpdated = {}

    if (filters) {
      Object.keys(filters).forEach(item => {
        if (item === "searchTerm") {
          filtersValuesUpdated.companyName = filters[item]
        } else if (item === "countryFilter" && filters[item]?.id) {
          filtersValuesUpdated.countryId = filters[item].id
        } else if (item === "industryFilter" && filters[item]?.id) {
          filtersValuesUpdated.industryId = filters[item].id
        } else if (item === "categoryFilter" && filters[item]?.id) {
          filtersValuesUpdated.category = filters[item].id
        } else if (item === "yearFilter" && filters[item]?.id) {
          filtersValuesUpdated.year = filters[item].id
        } else if (item === "filters") {
          const filtersArr = Object.values(filters[item])?.length
            ? flattenFilters(Object.values(filters[item]))
            : []

          filtersValuesUpdated.filters = filtersArr
        }
      })
    }

    let params = { ...filtersValuesUpdated }

    if (action.type === Actions.types.LOAD_COMPANIES_LOAD_MORE && offset) {
      params = { ...params, offset }
    }

    const result = yield call(getCompanyRanking, {
      searchTerm: params.companyName,
      industryId: params.industryId,
      countryId: params.countryId,
      category: params.category,
      filters: params.filters,
      offset: params.offset
    })

    const payload = result?.data?.getCompanyRanking

    if (action.type === Actions.types.LOAD_COMPANIES_LOAD_MORE) {
      yield put(Actions.loadMoreCompaniesSuccess(payload))
    } else {
      yield put(Actions.loadCompaniesSuccess(payload))
    }
  } catch (error) {
    if (action.type === Actions.types.LOAD_COMPANIES_LOAD_MORE) {
      yield put(Actions.loadMoreCompaniesFail())
    } else {
      yield put(Actions.loadCompaniesFail())
    }
  }
}

export function* saga() {
  yield takeLatest([Actions.types.LOAD_COMPANY_RANKINGS, Actions.types.LOAD_MORE], loadSaga)
  yield takeLatest(Actions.types.GET_SURVEY_COMPANIES, getSurveyCompaniesSaga)
  yield takeLatest([Actions.types.LOAD_COMPANIES, Actions.types.LOAD_COMPANIES_LOAD_MORE], loadCompaniesSaga)
}
